/**
 * Runtime environment configuration (Vite import.meta.env wrapped + typed).
 *
 * Vars públicas (prefijo VITE_*) inyectadas en build time per ambiente:
 * - VITE_WORKER_URL: base URL del Worker SISREP (CF Workers)
 * - VITE_DISTRITO_ID: distrito identifier (V1 hardcoded DGM-MTY-CUMBRES)
 */

interface PublicEnv {
  WORKER_URL: string;
  DISTRITO_ID: string;
  MODE: 'development' | 'production' | 'staging';
}

const rawEnv = import.meta.env;

function required(key: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(`Missing required env var: ${key}. Check .env.local or build-time injection.`);
  }
  return value;
}

// V1.0.3 hotfix: re-introducimos fallbacks porque CF Pages V1 deploy NO tiene
// VITE_DISTRITO_ID/VITE_WORKER_URL configurados (fail-fast del V1.0.2 dejó FE
// crasheando en producción). F-D1-01 cleanup queda DIFERIDO a V2 cuando se
// monte staging environment + CF Pages env vars per-tenant.
// V1.0.4 — Custom domain trefoilhub.com (mobile Safari ITP fix):
// FE en sisrep.trefoilhub.com + Worker en api.trefoilhub.com comparten eTLD+1
// trefoilhub.com → ITP los trata como same-site → cookies cross-subdomain OK.
const WORKER_URL_DEFAULT = 'https://api.trefoilhub.com';
const DISTRITO_ID_DEFAULT = 'DGM-MTY-CUMBRES';

export const env: PublicEnv = {
  WORKER_URL: required('VITE_WORKER_URL', rawEnv.VITE_WORKER_URL ?? WORKER_URL_DEFAULT),
  DISTRITO_ID: required('VITE_DISTRITO_ID', rawEnv.VITE_DISTRITO_ID ?? DISTRITO_ID_DEFAULT),
  MODE: rawEnv.MODE as PublicEnv['MODE'],
};
